import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import max from 'lodash';
import PromoCard from '@/components/promo-banner/PromoCard';
import Carousel from '@/components/Carousel';
import { concatenateArray } from '@/utils/miscellaneous';
import MsiDetails from './MsiDetails';
import useMobile from '@/hooks/useMobile';
import useEventContext from '@/contexts/event/useEventContext';
import { convertToTimeZone } from '@/locales/dates';
import useBoletiaConfig from '@/hooks/useBoletiaConfig';
import useMsci from '@/store/msci/useMsci';

export default function MsiBanner() {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  const {
    event: {
      event: { id },
    },
  } = useEventContext();

  const { msci: msi } = useMsci();

  const { isEventWithSaleLabel } = useBoletiaConfig();

  const getPreSaleDetail = (preSale) => {
    const maxOption = max(preSale.options);
    if (maxOption > 0) {
      return t('checkout.msi.getPeriod', { maxOption });
    }

    const endDate = convertToTimeZone(preSale.endAt);
    return t('checkout.msi.toDate', {
      day: endDate.format('D'),
      month: endDate.format('MMMM'),
    });
  };

  useEffect(() => {
    setMsiDetails(msi);
  }, []);

  return (
    <>
      {msi && (
        <Box
          sx={{
            mb: 2,
          }}
        >
          {msi.msi && msi.preSale ? (
            <Carousel
              relativeSize={isMobile ? 0.88 : 0.8}
              padding={isMobile ? 24 : 34}
              render={() => [
                <PromoCard
                  key={0}
                  title={t(
                    isEventWithSaleLabel(id)
                      ? 'checkout.msi.sale'
                      : 'checkout.msi.preSale',
                  )}
                  desc={`Con ${concatenateArray(
                    Object.keys(msi.preSale.banks),
                  )}`}
                  detail={getPreSaleDetail(msi.preSale)}
                  cta={t('checkout.msi.details')}
                  renderContent={(onClose) => (
                    <MsiDetails
                      data={msi.preSale}
                      title={t('checkout.msi.exclusivePreSale')}
                      onClose={onClose}
                    />
                  )}
                />,
                <PromoCard
                  key={1}
                  variant="secondary"
                  title={t('checkout.msi.short')}
                  detail={`Con ${concatenateArray(Object.keys(msi.msi.banks))}`}
                  desc={`Paga a ${concatenateArray(msi.msi.options)} MSI`}
                  cta={t('checkout.msi.details')}
                  renderContent={(onClose) => (
                    <MsiDetails
                      data={msi.msi}
                      title={t('checkout.msi.title')}
                      onClose={onClose}
                    />
                  )}
                />,
              ]}
            />
          ) : (
            <>
              {msi.msi && msi.msi.isToday && (
                <PromoCard
                  variant="secondary"
                  title={t('checkout.msi.short')}
                  detail={`${t('checkout.msi.with')} ${concatenateArray(
                    Object.keys(msi.msi.banks),
                    30,
                  )}`}
                  desc={`${t('checkout.msi.payTo')} ${concatenateArray(
                    msi.msi.options.filter((o) => o > 0),
                  )} ${t('checkout.msi.short')}`}
                  cta={t('checkout.msi.details')}
                  renderContent={(onClose) => (
                    <MsiDetails
                      data={msi.msi}
                      title={t('checkout.msi.title')}
                      onClose={onClose}
                    />
                  )}
                />
              )}
              {msi.preSale && (
                <PromoCard
                  title={t(
                    isEventWithSaleLabel(id)
                      ? 'checkout.msi.sale'
                      : 'checkout.msi.preSale',
                  )}
                  desc={`${t('checkout.msi.with')} ${concatenateArray(
                    Object.keys(msi.preSale.banks),
                  )}`}
                  detail={getPreSaleDetail(msi.preSale)}
                  cta={t('checkout.msi.details')}
                  renderContent={(onClose) => (
                    <MsiDetails
                      data={msi.preSale}
                      title={t('checkout.msi.exclusivePreSale')}
                      onClose={onClose}
                    />
                  )}
                />
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}
